module.exports = __webpack_public_path__ + "img/aura.def7a083.svg";